const Table = ({ children, className }: TableInterface) => {
  return (
    <>
      <table className={`${className} table table-auto w-full`}>
        {children}
      </table>
    </>
  )
}

export default Table
